module.exports = __webpack_public_path__ + "img/member-notfound.9c5ef8f4.svg";